module.exports = __webpack_public_path__ + "img/0Q3B5795_BlackMatted.cd986fb6.jpg";